import { types } from 'mobx-state-tree';

const ShippingSelectionFieldOption = types.model(
  'ShippingSelectionFieldOption',
  {
    value: types.identifierNumber,
    label: types.string
  }
);

export default ShippingSelectionFieldOption;
